
export default {
    changeEvent: 'dom-update'
}
